import { MedSummaryUpdateStatus, type UpdateProgress } from '../store/schemas'

// Stage word plus, during EXTRACTING only, a live "N of M files" count from the polled progress.
// Extraction is the only per-file stage; PENDING/MERGING/FINALIZING have no meaningful
// denominator, so they keep the bare stage word.
export function activeStatusLabel(status: MedSummaryUpdateStatus, progress?: UpdateProgress): string {
  switch (status) {
    case MedSummaryUpdateStatus.PENDING:
      return 'Queued...'
    case MedSummaryUpdateStatus.EXTRACTING: {
      // progress is missing before the first poll lands, and files_total is 0 until the worker
      // claims the run — fall back to the bare stage word in both windows.
      if (!progress || progress.files_total <= 0) return 'Extracting...'
      const done = Math.min(Math.max(progress.files_extracted + progress.files_included + progress.files_failed, 0), progress.files_total)
      return `Extracting... ${done} of ${progress.files_total} ${progress.files_total === 1 ? 'file' : 'files'}`
    }
    case MedSummaryUpdateStatus.MERGING:
      return 'Merging...'
    case MedSummaryUpdateStatus.FINALIZING:
      return 'Finalizing...'
    default:
      return 'Updating...'
  }
}
